module.exports = __webpack_public_path__ + "static/media/videoExploit.8c28b0cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/videoExploit.png
// module id = 201
// module chunks = 0